module.exports = __webpack_public_path__ + "static/media/checkmark-circle-black-big.ad98fbfb.svg";